import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  basePath: '/auth',
  fetchOptions: {
    credentials: 'include',
  },
});
